<template>
  <div class="wrap">
    <!-- 列表 -->
    <div class="special">
      <van-cell is-link @click="gotoUrl('/village/community')"
        ><img src="../../assets/shequ.png" class="linkicon" />我的社区</van-cell
      >
      <van-cell is-link @click="gotoUrl('/village/region')"
        ><img
          src="../../assets/xiaoqu.png"
          class="linkicon"
        />我的小区</van-cell
      >
      <van-cell is-link  @click="gotoUrl('/village/hygiene')"
        ><img
          src="../../assets/yiliaoweisheng.png"
          class="linkicon"
        />卫生医疗</van-cell
      >
      <van-cell is-link  @click="gotoUrl('/village/GridDoctor')"
        ><img
          src="../../assets/医生.png"
          class="linkicon"
        />网格医生</van-cell
      >
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import {WeMyMemberInfo, WxIsMember} from "@/api/yeguang";
import {getOpenId} from "@/utils/auth";
import {Toast} from "vant";

export default {
  components: {},
  data() {
    return {
      deptId:'',
      rId:''
    };
  },
  created() {
    this.MemberInfo();
  },
  methods: {
    MemberInfo() {
      WxIsMember({OpenID: getOpenId(),reqToken:''}).then((res) => {
        if (res.data.code == 0) {
          this.verifyshow = res.data.data.status;
          if (this.verifyshow == 1) {
            this.getMemberXq(res.data.data.Mobile);
          }
        } else {
          this.verifyshow = 0;
          Toast.fail(res.data.msg);
        }
      });
    },
    getMemberXq(phone) {
      WeMyMemberInfo({Mobile: phone}).then((res) => {
        if (res.data.code == "0") {
          // this.getAppletOrganList(res.data.data);
          this.deptId=res.data.data.orgCode;
          this.rId=res.data.data.rid;
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    //跳转到公共页面
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path+'?deptId='+this.deptId+'&rId='+this.rId,
        });
      } else {
        let url=path+'?deptId='+this.deptId+'&rId='+this.rId;
        this.$router.push(url);
      }
    },
  },
};
</script>

<style>
.wrap {
  background: #f7f8fa;
  min-height: 100%;
}
.special {
  padding: 10px 10px;
}
.special img {
  position: relative;
  top: 30%;
  margin-top: -10px;
  width: 24px;
  height: 24px;
}
</style>
